import { createBrowserRouter } from 'react-router-dom';

// project imports
import MainRoutes from './AppRoutes';
import LoginRoutes from './AuthRoutes';

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter([MainRoutes, LoginRoutes], { basename: "/" });

export default router;
